import { render } from "./ToolbarSection.vue?vue&type=template&id=6b2ef189&scoped=true"
import script from "./ToolbarSection.vue?vue&type=script&lang=js"
export * from "./ToolbarSection.vue?vue&type=script&lang=js"

import "./ToolbarSection.vue?vue&type=style&index=0&id=6b2ef189&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2ef189"]])

export default __exports__